"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoursesItem = void 0;
var React = __importStar(require("react"));
var useHeaderProps_1 = require("../../../hooks/useHeaderProps");
var useDisplayMode_1 = require("../useDisplayMode");
var DropdownOption_1 = require("../../_shared/DropdownOption");
var HeaderLink_1 = require("../../_shared/HeaderLink");
var NavLink_1 = require("../../_shared/NavLink");
var NavMenu_1 = require("../../_shared/NavMenu");
var CoursesItem = function () {
    var _a = (0, useHeaderProps_1.useHeaderProps)(), _js = _a._js, permissions = _a.permissions, activeItem = _a.activeItem;
    var displayMode = (0, useDisplayMode_1.useDisplayMode)();
    var links = (function () {
        var result = [
            {
                href: '/Courses',
                className: 'header-link__courses',
                dataFeatureId: 'header_link_courses',
                content: _js('Courses'),
            },
        ];
        if (permissions === null || permissions === void 0 ? void 0 : permissions.canIViewCoursesAdminIndex) {
            result.push({
                href: '/Courses/Manage',
                className: 'header-link__manage_courses',
                dataFeatureId: 'header_link_manage_courses',
                content: _js('Manage Courses'),
            });
        }
        return result;
    })();
    switch (displayMode) {
        case 'more':
            return (React.createElement(React.Fragment, null, links.map(function (link) { return (React.createElement(DropdownOption_1.DropdownOption, { key: link.dataFeatureId, href: link.href, className: link.className, "data-feature-id": link.dataFeatureId }, link.content)); })));
        case 'hamburger':
            return (React.createElement(React.Fragment, null, links.map(function (link) { return (React.createElement(NavLink_1.NavLink, { key: link.dataFeatureId, href: link.href, className: link.className, "data-feature-id": link.dataFeatureId }, link.content)); })));
        default:
            return links.length === 1 ? (React.createElement(HeaderLink_1.HeaderLink, { href: links[0].href, className: links[0].className, "data-feature-id": links[0].dataFeatureId, underlined: activeItem === 'courses' }, links[0].content)) : (React.createElement(NavMenu_1.NavMenu, null,
                React.createElement(NavMenu_1.NavMenuButton, { underlined: activeItem === 'courses', "date-feature-id": "header_dropdown_courses" }, _js('Courses')),
                React.createElement(NavMenu_1.NavMenuList, null, links.map(function (link) { return (React.createElement(DropdownOption_1.DropdownOption, { key: link.dataFeatureId, href: link.href, className: link.className, "data-feature-id": link.dataFeatureId }, link.content)); }))));
    }
};
exports.CoursesItem = CoursesItem;
